export default {
  RADIO_BUTTON_VERTICAL: 1,
  RADIO_BUTTON_HORIZONTAL: 2,
  INPUT_TEXT_CPF: 3,
  CHECKBOX_VERTICAL: 4,
  INPUT_TEXT_NUMERO_DECIMAL: 5,
  INPUT_TEXT_NUMERO_PESO:6,
  INPUT_TEXT_NUMERO_ALTURA:7,
  INPUT_TEXT_NUMERO_INTEIRO:8,
  INPUT_SELECT:9,
  INPUT_TEXT_TEXTO_SIMPLES:10,
  INPUT_SELECT2:11,
}



// WEBPACK FOOTER //
// ./src/config/TipoResposta.js